export const configPermission = {
    configView: "config.view",
    configDelete: "config.delete",
    configCreate: "config.create",
    configUpdate: "config.update"
};
